import { render, staticRenderFns } from "./depictionInf.vue?vue&type=template&id=39f06537&scoped=true"
import script from "./depictionInf.vue?vue&type=script&lang=js"
export * from "./depictionInf.vue?vue&type=script&lang=js"
import style0 from "./depictionInf.vue?vue&type=style&index=0&id=39f06537&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f06537",
  null
  
)

export default component.exports